export default __webpack_public_path__ + "static/media/ftm.db69b874.svg";